import API from '../Helper/FetchApi';

class QuestionnaireTemplatesService {
    /**@GET_ALL_TEMPLATES */
    async getAllTemplates() {
        return await API.fetchGet('/questionnaire-templates');
    }

    /**@CREATE_TEMPLATE */
    async createTemplate(formData: FormData) {
        return await API.fetchFormDataPost('/questionnaire-templates', formData);
    }

    /**@GET_TEMPLATE_BY_ID */
    async getTemplateById(id: string) {
        return await API.fetchGet(`/questionnaire-templates/${id}`);
    }

    /**@UPDATE_TEMPLATE */
    async updateTemplate(id: string, formData: FormData) {
        return await API.fetchFormDataPut(`/questionnaire-templates/${id}`, formData);
    }

    /**@DELETE_TEMPLATE */
    async deleteTemplate(id: string) {
        return await API.fetchDelete(`/questionnaire-templates/${id}`, null);
    }

    /**@GET_TEMPLATE_QUESTIONS */
    async getTemplateQuestions(id: string) {
        return await API.fetchGet(`/questionnaire-templates/${id}/questions`);
    }
}

export default new QuestionnaireTemplatesService(); 